import React from 'react';
import PropTypes from 'prop-types';

import { IconClose } from '../../assets/icon';
import Text from '../Text/Text';

const SelectedCarList = ({ cars, onDelete }) => {
  return (
    <div>
      {cars.map((car, index) => (
        <div
          key={`${['cat', index].join('_')}`}
          className="flex flex-row justify-between items-center"
        >
          <div className="flex-1">{car?.make}</div>
          <div className="text-center flex-1">{car?.model}</div>
          <div className="text-right flex-1 overflow-hidden whitespace-nowrap text-ellipsis">
            {car?.year?.join(',')}
          </div>
          {onDelete && (
          <div role="presentation" onClick={() => onDelete(index)}>
            <IconClose color="#F1416C" className="w-[25px] h-[25px] cursor-pointer flex hover:text-primary" />
          </div>
          )}
        </div>
      ))}
      {!cars?.length && <Text text="No cat selected" />}
    </div>
  );
};

SelectedCarList.propTypes = {
  cars: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onDelete: PropTypes.func
};

SelectedCarList.defaultProps = {
  onDelete: undefined
};

export default SelectedCarList;
